import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useListContext, useTranslate } from 'react-admin';
import NoteResolver from './NoteResolver';

const NotesListBody: React.FC = () => {
    const { ids, data, loading } = useListContext();
    const t = useTranslate();

    if (!loading && (!ids || ids.length === 0)) {
        return (
            <Box display='grid' gridTemplateRows='auto 1fr' gridGap={8} style={{ background: '#eef2f6' }}>
                <Box display='grid' gridGap={8} style={{ background: '#eef2f6' }}>
                    <Typography variant='body2' color='textSecondary' style={{ padding: 8 }}>
                        {t('app.objects.noNotes')}
                    </Typography>
                </Box>
            </Box>
        );
    }

    return (
        <Box
            style={{
                display: 'grid',
                gap: 8,
                alignItems: 'start',
                alignContent: 'start',
            }}
        >
            {ids &&
                ids.map((id: any) => {
                    const record = data && (data as any)[id];
                    if (!record) return null;
                    return <NoteResolver key={record.id || record['@id'] || id} note={record} />;
                })}
        </Box>
    );
};

export default NotesListBody;
